<script setup lang="ts">
  import { onMounted, reactive, useTemplateRef } from 'vue'

  const props = defineProps<{
    announcement: string
  }>()

  const emit = defineEmits<{
    confirm: [announcement: string]
    cancel: []
  }>()

  const rootEl = useTemplateRef<HTMLDivElement>('rootEl')
  const state = reactive({
    announcement: '',
  })

  onMounted(() => {
    rootEl.value?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
    state.announcement = props.announcement
  })
</script>

<template>
  <div
    class="w-full max-w-2xl rounded-xl border border-red-400/80 bg-purple-500 p-8 text-white shadow-2xl"
    ref="rootEl"
  >
    <div class="flex h-full flex-col">
      <h2 class="font-display text-center text-3xl font-bold">Set Island Announcement</h2>

      <!-- Input Section -->
      <div class="mt-6 mb-8 flex flex-col items-center gap-4 text-center">
        <p>Set the announcement for your island:</p>
        <textarea
          v-model="state.announcement"
          class="h-24 w-full resize-none rounded-lg border-2 border-white/20 bg-white/5 p-4 text-white focus:border-green-400 focus:outline-none"
        ></textarea>
      </div>
      <!-- Action -->
      <div class="flex justify-center gap-4">
        <button
          @click="emit('confirm', state.announcement)"
          class="cursor-pointer rounded-lg bg-green-400 px-8 py-2 font-bold text-black transition-colors hover:bg-green-500"
        >
          Announce!
        </button>
        <button
          @click="emit('cancel')"
          class="bg-base-orange cursor-pointer rounded-lg px-8 py-2 font-bold text-black transition-colors hover:bg-red-500"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
